import React, { useEffect, useState } from 'react';
import getDiscountAmountByProduct from '../../resolvers/getDiscountAmountByProduct';
import getDiscountDaysByProduct from '../../resolvers/getDiscountDaysByProduct';

export default function TableDiscount({ currency, product }) {
    const [discountCost, setDiscountCost] = useState('-');
    const discountDays = getDiscountDaysByProduct(product) ? getDiscountDaysByProduct(product) + ' days' : '';
    const sign = <span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>;

    useEffect(() => {
        setDiscountCost(
            <>
                {sign}
                {Number(getDiscountAmountByProduct(product) * currency?.rate).toFixed(2)}
            </>
        );
    }, [currency]);

    // DB API has a different discounts UI.
    if (product?.product_id === 2 && product?.bonus_amount > 0) {
        return (
            <div className={'section__row section__row--extra'}>
                <div className={'section__cell section__cell--name' }>
                <p className={'text bold'}>
                    <span className={'color--blue-2'}>{product?.bonus_amount} {product?.units ?? 'checks'}</span> available as bonus from previous license
                </p>
                </div>
                <div className={'section__cell section__cell--billing tablet-pb-7'}></div>
                <div className={'section__cell section__cell--sites tablet-pt-7 tablet-pb-7 hide-tablet'}></div>
                <div className={'section__cell section__cell--per-site tablet-pt-7 tablet-pb-7 hide-tablet'}></div>
                <div className={'section__cell section__cell--sum tablet-pt-7'}></div>
            </div>
        );
    }

    return (
        <div className={'section__row section__row--extra'}>
            <div className={'section__cell section__cell--name'}>
                <span className={'text'}>
                    Discount for unused balance on the current package
                </span>
            </div>
            <div className={'section__cell section__cell--billing tablet-pb-7'}>
                <span className={'text-3 bold hide-desktop'}>Billing period</span>
                <span className={'text-3'}>{discountDays}</span>
            </div>
            <div
                className={'section__cell section__cell--sites tablet-pt-7 tablet-pb-7 hide-tablet'}
            >
                <span className={'text-3 bold hide-desktop'}>Sites</span>
                <span className={'text-3'}>-</span>
            </div>
            <div
                className={
                    'section__cell section__cell--per-site tablet-pt-7 tablet-pb-7 hide-tablet'
                }
            >
                <span className={'text-3 bold hide-desktop'}>Cost per site</span>
                <span className={'text-3'}>-</span>
            </div>
            <div className={'section__cell section__cell--sum tablet-pt-7'}>
                <span className={'text-3 bold hide-desktop'}>Sum</span>
                <span className={'text-3'}>{discountCost}</span>
            </div>
        </div>
    );
}
